import { Component, ViewChild, ElementRef, AfterViewInit } from '@angular/core';
import { DefaultEditor } from 'ng2-smart-table';

@Component({
  template: `
    <div class="input-group mb-3" style="margin-top:15px;">

      <input [ngClass]="inputClass"
             #loanTerm
             min="0"
             class="form-control short-input"
             type="number"
             [name]="cell.getId()"
             [placeholder]="'Auto'"
             [disabled]="!cell.isEditable()"
             (click)="onClick.emit($event)"
             (keyup)="updateValue()"
             (keydown.enter)="onEdited.emit($event)"
             (keydown.esc)="onStopEditing.emit()"
             style="width: 72px;"
      />
        <div class="input-group-append" style="">
        <span class="input-group-text arial bold centered-text"
              style="height:35px;
                padding-left:3px;
                padding-right:3px;
                padding-top:7px;
                font-size: small;">
          Years
        </span>
        </div>
    </div>`,
})
export class CustomYearEditorComponent extends DefaultEditor implements AfterViewInit {

  @ViewChild('loanTerm', { static: false }) loanTerm: ElementRef;

  constructor() {
    super();
  }

  ngAfterViewInit() {
    if (this.cell.newValue !== '') {
      this.loanTerm.nativeElement.value = this.cell.newValue;
    }
  }

  updateValue() {
    this.cell.newValue = this.loanTerm.nativeElement.value;
  }

}
